module.exports = __webpack_public_path__ + "img/cx.09db1384.svg";